// เปลี่ยนหน้าแบบไม่ reload (SPA) — ใช้ได้กับทุก React root
// คลิกลิงก์ภายในเว็บ (<a href="/slot">) จะเปลี่ยน URL + แจ้งทุกส่วนผ่าน popstate แทนการโหลดหน้าใหม่
// BrowserRouter (App.js), main.js, sidebar, MemberHub, GameLobby ฟัง popstate อยู่แล้ว

export function navigate(path, { replace = false } = {}) {
  if (!path) return;
  const url = new URL(path, window.location.href);
  if (url.origin !== window.location.origin) { window.location.href = url.href; return; }
  const next = url.pathname + url.search + url.hash;
  const cur = window.location.pathname + window.location.search + window.location.hash;
  if (next !== cur) {
    if (replace) window.history.replaceState(null, '', next);
    else window.history.pushState(null, '', next);
  }
  window.dispatchEvent(new PopStateEvent('popstate', { state: null }));
  if (!url.hash) window.scrollTo(0, 0);
}

// ลิงก์ที่ต้องโหลดหน้าจริง (ไฟล์, ออกจากระบบ ฯลฯ)
const FULL_RELOAD = [/^\/logout/, /^\/local-assets\//, /^\/build\//, /^\/static\//, /\.(pdf|zip|apk|png|jpe?g|gif|webp|svg|mp4)$/i];

export function installLinkInterceptor() {
  if (window.__spaLinks) return;
  window.__spaLinks = true;
  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    const href = a.getAttribute('href');
    if (!href || href.startsWith('#') || /^(mailto:|tel:|javascript:)/i.test(href)) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('download') || a.hasAttribute('data-toggle') || a.hasAttribute('data-bs-toggle') || a.dataset.reload !== undefined) return;
    let url;
    try { url = new URL(href, window.location.href); } catch (err) { return; }
    if (url.origin !== window.location.origin) return;
    if (FULL_RELOAD.some((re) => re.test(url.pathname))) return;
    e.preventDefault();
    navigate(url.pathname + url.search + url.hash);
  });
}
